
    // Base Wallet será definido no script principal
    console.log('Base Wallet será carregado pelo script principal');
  